import React from 'react';
import menuImg from "../../../assets/images/menu-img.png";

const MenuIcon = () => {
  return (
    <img src={menuImg} style={{height: '12px', marginRight: '-2px'}}/>
  );
};

export default MenuIcon;